<div class="container">
  <div class="matrimoni-header">
    <h1 class="page-title">{{ "weddings.title" | translate }}<br /><em>{{ "weddings.title_sub" | translate }}</em></h1>
    <button id="tour-eventi-new" class="add-button" (click)="openCreateForm()">
      + {{ "weddings.add" | translate }}
    </button>
  </div>

  <!-- TOOLBAR -->
  <div class="toolbar" [class.filters-open]="filtersOpen">
    <!-- Su mobile: apre/chiude tipo+anno+vista, per lasciare la ricerca subito visibile -->
    <button type="button" class="mobile-filter-toggle" (click)="toggleFilters()">
      <span><app-icon name="search" [size]="15" /> {{ "weddings.filters_toggle" | translate }}</span>
      <span class="mobile-filter-count" *ngIf="activeFilterCount > 0">{{ activeFilterCount }}</span>
      <span class="mobile-filter-chevron" [class.open]="filtersOpen">▾</span>
    </button>

    <!-- Pill tipo -->
    <div class="filter-btns">
      <button
        [class.active]="filterType === 'all'"
        (click)="filterType = 'all'"
      >
        {{ "weddings.filters.all" | translate }}
      </button>
      <button
        [class.active]="filterType === 'upcoming'"
        (click)="filterType = 'upcoming'"
      >
        {{ "weddings.filters.upcoming" | translate }}
      </button>
      <button
        [class.active]="filterType === 'past'"
        (click)="filterType = 'past'"
      >
        {{ "weddings.filters.past" | translate }}
      </button>
      <button
        *ngIf="quoteCount > 0 || onlyQuotes"
        [class.active]="onlyQuotes"
        (click)="onlyQuotes = !onlyQuotes"
      >
        {{ "quote.filter" | translate }} ({{ quoteCount }})
      </button>
    </div>

    <!-- Pill anni -->
    <div class="year-pills" *ngIf="availableYears.length > 1">
      <button
        *ngFor="let year of availableYears"
        class="year-pill"
        [class.active]="selectedYear === year"
        (click)="toggleYear(year)"
      >
        {{ year }}
      </button>
    </div>

    <div class="filter-btns" [attr.aria-label]="'weddings.sort.label' | translate">
      <button [class.active]="sortBy === 'date'" (click)="sortBy = 'date'">
        {{ "weddings.sort.date" | translate }}
      </button>
      <button [class.active]="sortBy === 'created'" (click)="sortBy = 'created'">
        {{ "weddings.sort.created" | translate }}
      </button>
    </div>

    <!-- Ricerca smart -->
    <div class="search-wrap">
      <input
        type="text"
        [placeholder]="'weddings.search_bride' | translate"
        [(ngModel)]="searchText"
        (input)="updateSuggestions()"
        (focus)="showSuggestions = true"
        (blur)="showSuggestions = false"
        class="search-input"
      />
      <ul
        class="suggestions-list"
        *ngIf="showSuggestions && suggestions.length > 0"
      >
        <li *ngFor="let s of suggestions" (mousedown)="selectSuggestion(s)">
          {{ s }}
        </li>
      </ul>
    </div>

    <!-- Toggle Lista / Mappa -->
    <div class="filter-btns view-toggle">
      <button [class.active]="viewMode === 'list'" (click)="viewMode = 'list'">
        {{ "weddings.view_list" | translate }}
      </button>
      <button [class.active]="viewMode === 'map'" (click)="showMapView()">
        {{ "weddings.view_map" | translate }}
        <span *ngIf="!canProMaps" class="pro-lock"><app-icon name="lock" [size]="12" /></span>
      </button>
    </div>
  </div>

  <app-load-error *ngIf="loadError" (retry)="load()"></app-load-error>

  <app-events-map *ngIf="viewMode === 'map'" [events]="filteredEvents"></app-events-map>

  <ng-container *ngIf="viewMode === 'list'">

  <ng-container *ngIf="filteredEvents.length > 0; else empty">
    <!-- FEATURED: prossimo evento -->
    <div
      class="featured-card"
      *ngIf="nextWedding"
      [routerLink]="['/evento', nextWedding._id]"
    >
      <div class="featured-left">
        <span class="featured-eyebrow">{{ "weddings.next" | translate }}<ng-container *ngIf="isQuote(nextWedding)"> · {{ "quote.badge" | translate }}</ng-container></span>
        <h2 class="featured-name">
          {{ nextWedding.client.name }} {{ nextWedding.client.lastname }}
        </h2>
        <div class="featured-meta">
          <span class="featured-date">{{
            nextWedding.event.date | date: "dd MMMM yyyy"
          }}</span>
          <span class="featured-sep">·</span>
          <span class="featured-location">{{
            nextWedding.event.location
          }}</span>
        </div>
        <div class="featured-tags">
          <span *ngFor="let s of getServices(nextWedding)">{{ s }}</span>
        </div>
        <span class="featured-cta">{{ "weddings.open_card" | translate }}</span>
      </div>
      <div class="featured-right">
        <div class="countdown">
          <span class="countdown-number">{{
            daysUntil(nextWedding.event.date)
          }}</span>
          <span class="countdown-label">{{ "weddings.countdown" | translate }}</span>
        </div>
      </div>
    </div>

    <!-- GRIGLIA raggruppata per mese/anno -->
    <ng-container *ngIf="otherWeddings.length > 0">
      <div *ngFor="let group of groupedWeddings" class="month-group">
        <div class="month-label" *ngIf="group.label">{{ group.label }}</div>
        <div id="tour-eventi-list" class="card-list">
          <div
            class="card"
            *ngFor="let evento of group.items; let i = index"
            [class.collaboration]="evento.is_collaboration"
            [class.quote]="isQuote(evento)"
            [style.animation-delay]="i * 60 + 'ms'"
            [routerLink]="['/evento', evento._id]"
          >
            <div class="card-date">
              {{ dateLabel(evento) }}
            </div>
            <h2 class="card-name">
              {{ evento.client.name }} {{ evento.client.lastname }}
            </h2>
            <p class="card-location">{{ evento.event.location }}</p>
            <div class="card-tags">
              <span *ngFor="let s of getServices(evento)">{{ s }}</span>
            </div>
            <span class="collab-badge" *ngIf="evento.is_collaboration">
              {{ "weddings.collaboration" | translate }}
            </span>
            <span class="quote-badge" *ngIf="isQuote(evento)">
              {{ "quote.badge" | translate }}
            </span>
            <span class="quote-badge" *ngIf="needsDate(evento)">
              {{ "quote.date_to_set" | translate }}
            </span>
            <span class="card-cta">{{ "weddings.open" | translate }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- COLLABORAZIONI -->
    <ng-container *ngIf="collaborations && collaborations.length > 0">
      <div class="month-group">
        <div class="month-label collab-label">{{ "weddings.collaborations" | translate }}</div>
        <div class="card-list">
          <div
            class="card collaboration"
            *ngFor="let w of collaborations; let i = index"
            [style.animation-delay]="i * 60 + 'ms'"
            [routerLink]="['/evento', w._id]"
          >
            <div class="card-date">{{ w.date | date: "dd/MM/yyyy" }}</div>
            <h2 class="card-name">{{ w.bride_name }}</h2>
            <p class="card-location">{{ w.location }}</p>
            <span class="collab-badge">{{ "weddings.collaboration" | translate }}</span>
            <span class="card-cta">{{ "weddings.open" | translate }}</span>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>
  </ng-container>

  <ng-template #empty>
    <p class="empty-state" *ngIf="!loadError">{{ "weddings.empty" | translate }}</p>
  </ng-template>
</div>
